import 'react';
import { usePopover, PopoverProvider } from './context.js';
import { useIsMobile } from '../../hooks/useIsMobile.js';
import warnDeprecation from '../../utils/warnDeprecation.js';
import { jsx } from '@emotion/react';
import '@indeed/ihl-use-id';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../utils/warn.js';

function isFunction(value) {
  return typeof value === "function";
}

/**
 * Popover
 *
 * @see https://experience.indeed.design/components/ids/popover
 *
 * @deprecated The `Popover` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */
const Popover = _ref => {
  let {
    children,
    mobile,
    ...props
  } = _ref;
  warnDeprecation(deprecationWarning);
  const isMobile = useIsMobile(mobile);
  const context = usePopover({
    ...props,
    isMobile
  });
  const popoverChildren = isFunction(children) ? children(context) : children;
  return jsx(PopoverProvider, {
    value: context
  }, popoverChildren);
};
Popover.displayName = "Popover";
const deprecationWarning = `[Popover] The Popover component will be removed in IFL 7. See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide`;

export { Popover };
